"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {
              Topics: [
                  {
                      id: "...",
                      label: "User Control"
                    },
                  {
                      id: "...",
                      label: "Certificate"
                    },
                  {
                      id: "...",
                      label: "Learning Analytics"
                    },
                  {
                      id: "...",
                      label: "Meetings"
                    },
                  {
                      id: "...",
                      label: "Account & Security"
                    },
                  {
                      id: "...",
                      label: "Customization"
                    }
                ],
              searchSuggestions: [
                  {
                      id: "...",
                      label: "How to create a department?"
                    },
                  {
                      id: "...",
                      label: "Process of deleting a department"
                    },
                  {
                      id: "...",
                      label: "How to assign a course to my department?"
                    }
                ]
            };
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/FeedHelp/components/Helps.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    SearchBar_template = require("../../../../components/SearchBar/index.marko"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Button_template = require("../../../../components/Button/index.marko"),
    Button_tag = marko_loadTag(Button_template),
    marko_attrs0 = {
        "class": "helps"
      },
    marko_attrs1 = {
        "class": "font-medium-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("5de068"),
    marko_node0 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_node1 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "text-muted border-top"
      },
    marko_node3 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "list-style-square font-medium-2 text-muted p-0 pl-4"
      },
    marko_node5 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "17", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "text-muted"
      },
    marko_node7 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "list-inline"
      },
    marko_attrs7 = {
        "class": "d-block py-75 cursor-pointer"
      },
    marko_attrs8 = {
        "class": "mr-1 m-25 "
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("h5", marko_attrs1, "1", component);

  Locale_tag({
      text: "Help Session"
    }, out, __component, "2");

  out.ee();

  out.n(marko_node0, component);

  out.be("div", marko_attrs2, "4", component);

  SearchBar_tag({
      size: "xl",
      icon: "bx-help-circle font-medium-5",
      target: "help",
      minLength: 3,
      suggestions: state.searchSuggestions,
      placeholder: Locale("Search for help ...")
    }, out, __component, "5", [
    [
      "blur",
      "onSearchDismiss",
      false
    ],
    [
      "result",
      "onSearchResult",
      false
    ],
    [
      "select",
      "onSelectSuggestion",
      false
    ]
  ]);

  out.ee();

  out.n(marko_node1, component);

  out.n(marko_node2, component);

  out.be("p", marko_attrs3, "8", component);

  out.n(marko_node3, component);

  out.n(marko_node4, component);

  Locale_tag({
      text: "Suggestions"
    }, out, __component, "11");

  out.ee();

  out.be("ul", marko_attrs4, "12", component);

  var $for$0 = 0;

  marko_forOf(state.Topics, function({ id, label }, index) {
    var $keyScope$0 = "[" + (($for$0++) + "]");

    out.be("li", null, "13" + $keyScope$0, component);

    out.be("u", marko_attrs7, "14" + $keyScope$0, component, null, 0, {
        onclick: __component.d("click", "onSelect", false, [
            id
          ])
      });

    Locale_tag({
        text: label
      }, out, __component, "15" + $keyScope$0);

    out.ee();

    out.ee();
  });

  out.ee();

  out.n(marko_node5, component);

  out.n(marko_node6, component);

  out.be("p", marko_attrs5, "18", component);

  out.n(marko_node7, component);

  Locale_tag({
      text: "Other Topics"
    }, out, __component, "20");

  out.ee();

  out.be("ul", marko_attrs6, "21", component);

  marko_forOf(state.Topics, function({ id, label }, index) {
    var $keyValue$1 = "@" + index,
        $keyScope$1 = "[" + ($keyValue$1 + "]");

    out.be("li", marko_attrs8, $keyValue$1, component);

    Button_tag({
        class: "btn theme-bg-fade",
        renderBody: function(out) {
          Locale_tag({
              text: label
            }, out, __component, "23" + $keyScope$1);
        }
      }, out, __component, "22" + $keyScope$1, [
      [
        "change",
        "onSelect",
        false,
        [
            id
          ]
      ]
    ]);

    out.ee();
  });

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
